<template>
  <div class="accountDetail">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text v-if="!data.account.id" style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          后台开通客户账号
        </el-text>
        <el-text v-if="data.account.id" style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          客户管理
        </el-text>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="">
        <el-avatar v-if="data.account.avatar" shape="square" :size="100" :src="data.account.avatar" style="margin: auto; border-radius: 10%;box-shadow: 10px 10px 10px #666;" />
      </el-form-item>
      <el-form-item label="昵称">
        <el-input v-model="data.account.nick" :disabled="data.account.id" />
      </el-form-item>
      <el-form-item label="电话号（账号）">
        <el-input v-model="data.account.phone" :disabled="data.account.id" />
      </el-form-item>
      <el-form-item label="初始密码" v-if="!data.account.id">
        <el-input v-model="data.account.password" />
      </el-form-item>
      <el-form-item label="创建时间" v-if="data.account.createDatetime">
        <el-input :value="util.parseTime(data.account.createDatetime)" disabled />
      </el-form-item>
      <el-form-item label="VIP状态">
        <el-switch style="width: 500px;" v-model="data.account.vip" active-text="是" inactive-text="否" />
      </el-form-item>
      <el-form-item label="VIP到期时间">
        <el-date-picker style="width: 500px;" value-format="YYYY-MM-DD HH:mm:ss" v-model="data.account.vipDatetime" type="datetime" />
      </el-form-item>
      <el-form-item label="初级报告次数">
        <el-input style="width: 500px;" v-model="data.account.report2Quantity" :disabled="data.account.id" />
      </el-form-item>      
      <el-form-item label="高阶报告次数">
        <el-input style="width: 500px;" v-model="data.account.reportQuantity" :disabled="data.account.id" />
      </el-form-item>
      <el-form-item label=" " v-if="data.account.id">
        <el-link style="width: 180px;" @click="show.editingReportQuantity = true">编辑剩余报告生成次数</el-link>
      </el-form-item>
    </el-form>
  </div>

  <el-dialog v-model="show.editingReportQuantity" title="编辑剩余生成报告次数" width="700">
    <el-text>【初级报告】调整：</el-text>
    <el-input-number style="width: 150px" :precision="0" v-model="data.editingReport2Quantity" />
    <el-text>次。</el-text>
    <el-text>预期调整后，剩余：</el-text>
    <el-text style="color: #000; font-weight: bolder;">{{ math.plus(data.account.report2Quantity, data.editingReport2Quantity) }}</el-text>
    <el-text>次。</el-text>
    <br />
    <br />
    <el-text>【高阶报告】调整：</el-text>
    <el-input-number style="width: 150px" :precision="0" v-model="data.editingReportQuantity" />
    <el-text>次。</el-text>
    <el-text>预期调整后，剩余：</el-text>
    <el-text style="color: #000; font-weight: bolder;">{{ math.plus(data.account.reportQuantity, data.editingReportQuantity) }}</el-text>
    <el-text>次。</el-text>
    <br />
    <br />
    <el-text type="info">调整说明：</el-text>
    <br />
    <el-text type="info">1. 填写正数，增加次数；填写负数，减少次数。</el-text>
    <br />
    <el-text type="info">2. 次数最多减少到0。</el-text>
    <br />
    <el-text type="info">3. 实际调整只按变化量调整。调整时，如果同时有其他人在进行操作，结果和预期会有偏差。</el-text>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="show.editingReportQuantity = false">{{ util.language('取消', 'Cancel') }}</el-button>
        <el-button type="primary" @click="submitEditingReportQuantity" :loading="loading.editingReportQuantity">{{ util.language('确认调整', 'OK') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const loading = reactive({
  save: false,
  editingReportQuantity: false
})
const show = reactive({
  roles: [],
  editingReportQuantity: false
})
const pageParam = cache.getObject(cache.keys.pageParam + "accountDetail")
const data = reactive({
  account: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {},
  editingReport2Quantity: 0,
  editingReportQuantity: 0
})

if (data.account.id) {
  api.get('/backend/account/getById', {
    params: {
      id: data.account.id
    }
  }).then(res => {
    data.account = res
    if (data.account.header) {
      const headers = util.json2Elfile(data.account.header)
      if (headers && headers.length > 0) {
        data.account.avatar = headers[0].url
      }
    }
  })
}

const save = () => {
  loading.save = true
  if (!data.account.id) {
    data.account.newPassword = data.account.password
    api.post('/backend/account/add', data.account).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  } else {
    api.post('/backend/account/setVip', {
      id: data.account.id,
      vip: data.account.vip,
      vipDatetime: data.account.vipDatetime,
    }).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  }
}

const submitEditingReportQuantity = () => {
  if (!data.editingReport2Quantity && !data.editingReportQuantity) {
    ElMessage.error('请填写调整的次数')
    return
  }
  loading.editingReportQuantity = true
  api.post('/backend/account/setReportQuantity', {
    id: data.account.id,
    report2Quantity: data.editingReport2Quantity || 0,
    reportQuantity: data.editingReportQuantity || 0
  }).then(res => {
    data.account.report2Quantity = res.report2Quantity
    data.account.reportQuantity = res.reportQuantity
    ElMessage.success('编辑成功')
    show.editingReportQuantity = false
  }).finally(() => {
    loading.editingReportQuantity = false
  })
}
</script>

<style lang="less">
.accountDetail {
  margin: auto;
  max-width: 900px;
}
</style>